<template>
  <div class="aw-astack-manage">
    
    <div></div>
    <div class="com-sub-top">
      <div class="title container-center">AWSTACK超融合一体机</div>
    </div>
    <div class="com-tab-box">
        <div class="p-box container-center">
            <p :class="{'active': key == '1'}" @click="choose('1')">AWSTACK机架式超融合一体机</p>
            <p :class="{'active': key == '2'}" @click="choose('2')">AWSTACK水冷静音超融合一体机</p>
        </div>
    </div>
    <div class="com-desc-box">
      <div class="container-center com-center">
        <p class="title">{{key == '1'? 'AWSTACK机架式超融合一体机': 'AWSTACK水冷静音超融合一体机'}}</p>
        <p class="machine-desc">{{key == '1'? '型号：AWSTACK D200、AWSTACK D300、AWSTACK H300': '型号：AWSTACK S300'}}</p>
        <p class="title" style="margin-top:60px">产品简介</p>
        <p class="desc" v-if="key=='1'">          
          海云捷迅 AWSTACK 机架式超融合一体机，是一套基于超融合架构的 IT 基础设施平台，其遵循全新的开放架构标准，有多种表现形式：<br/>
          ○机架式服务器⸺适合标准机架和数据中心环境，可同时支持分布式存储和集中式存储，最具普适性。<br/>
          ○一体化设备⸺集成机柜、标准服务器、冗余网络设备和电力供应设备，在存储容量、扩展性上更胜一筹。
        </p>
        <p class="desc" v-if="key=='2'">
            海云捷迅 AWSTACK 水冷静音超融合一体机于一台 25U 定制化机柜中集成了高性能静音服务器、全冗余静音交换机和 UPS设备，在降噪、散热、供电方面进行了优化处理，同时配合软硬件系统的高可用设计，有效降低了因外部原因造成的业务停顿甚至数据损坏的概率。使企业新业务上线周期从数月缩减到数小时，企业运营效率大幅提升，运维成本大幅降低。
        </p>
        <img
          v-if="key=='1'"
          class="aw-awstack1"
          src="@/assets/awstack/AWSTACK_img_1_1.png"
          alt=""
        />
        <img
          v-if="key=='2'"
          class="aw-awstack2"
          src="@/assets/awstack/AWSTACK_img_2_1.png"
          alt=""
        />
      </div>
    </div>

    <div class="com-desc-box">
      <div class="container-center com-center">
        <p class="title">产品优势</p>
        <ul class="com-product-desc">
          <li>
              <img v-if="key=='1'" src="@/assets/awstack/AWSTACK_icon_1_1@2x.png" alt="" />
              <img v-else src="@/assets/awstack/AWSTACK_icon_3_1@2x.png" alt="" />
              <h5>{{key=='1'? '标准' : '安静可靠'}}</h5>
              <p class="desc">{{key=='1'? '标准硬件，兼容性强，扩展性高，适合大规模快速扩展。' : '改变传统散热方式，大大降低了设备产生的噪音，同时不影响性能。'}}</p>
          </li>
          <li>
              <img v-if="key=='1'" src="@/assets/awstack/AWSTACK_icon_1_2@2x.png" alt="" />
              <img v-else src="@/assets/awstack/AWSTACK_icon_3_2@2x.png" alt="" />
              <h5>{{key=='1'? '集成' : '安全可用'}}</h5>
              <p class="desc">
                {{key=='1'? '计算、存储、网络集成虚拟化统一的监控运维平台，开箱即用。' : '全冗余设计，保障硬件安全；单点故障不会造成数据丢失或业务停顿；集群自动化管理，出现故障可自动恢复。'}}
              </p>
          </li>
          <li>
              <img v-if="key=='1'" src="@/assets/awstack/AWSTACK_icon_1_3@2x.png" alt="" />
              <img v-else src="@/assets/awstack/AWSTACK_icon_3_3@2x.png" alt="" />
              <h5>{{key=='1'? '快速' : '高度集成'}}</h5>
              <p class="desc">{{key=='1'? '硬件设备一体化交付，软件自动化部署，运维投入少，交付速度快。' : '一体化设计，预留可扩展空间，方便集成防火墙、集中存储等第三方设备。'}}</p>
          </li>
           <li>
              <img v-if="key=='1'" src="@/assets/awstack/AWSTACK_icon_1_4@2x.png" alt="" />
              <img v-else src="@/assets/awstack/AWSTACK_icon_3_4@2x.png" alt="" />
              <h5>{{key=='1'? '灵活' : '直观监控'}}</h5>
              <p class="desc">{{key=='1'? 'OpenStack开放架构，兼容企业传统IT架构，按照实际需求自定义配置，平衡性能和降低成本。' : '内置触摸监控屏，第一时间了解到一体机的软硬件状态，故障告知变被动为主动。'}}</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="com-desc-box">
      <div class="container-center com-center">
        <p class="title">产品特点</p>
        <p class="desc">
          {{key=='1'? '满足企业通过软硬一体设备建设标准X86架构的云化数据中心业务需要，工厂预安装AWSTACK私有云平台，向企业交付标准的、规范的云数据中心产品，快部署、智运维、易使用、便管理。' : '通过水冷静音超融合一体机实现“云平台+服务器+网络+UPS+机柜”一体化交付，只需一个网口、一个16A电源，为客户提供“办公室里的数据中心”。工厂预安装AWCloud私有云平台，开箱即用。'}}
        </p>
        
        <img
          v-if="key=='1'"
          class="aw-pro-charact"
          src="@/assets/awstack/AWSTACK_img_1_2.png"
          alt=""
        />
        <img
          v-else
          class="aw-pro-charact2"
          src="@/assets/awstack/AWSTACK_img_2_2.png"
          alt=""
        />
      </div>
    </div>

    <div class="com-desc-box">
      <div class="container-center com-center">
        <p class="title">应用场景</p>
        <ul class="com-scene-desc">
           <li :style="{'background-image': key == '1' ? 'url(' + require('@/assets/awstack/AWSTACK_img_2_1@2x.png') + ')' : 'url(' + require('@/assets/awstack/AWSTACK_img_2_3@2x.png') + ')'}">
            <p class="desc">
                {{key=='1'? '任何标准化的机房和数据中心' : '对服务器、网络设备和电力供应设备有一体化交付要求的场景'}}
            </p>
          </li>
          <li :style="{'background-image': key == '1' ? 'url(' + require('@/assets/awstack/AWSTACK_img_2_2@2x.png') + ')' : 'url(' + require('@/assets/awstack/AWSTACK_img_2_4@2x.png') + ')'}">
            <p class="desc">{{key=='1'? '需要同时支持分布式存储和集中式存储的场景' : '对容量、安全性要求较高的场景'}}</p>
          </li>
          <li :style="{'background-image': key == '1' ? 'url(' + require('@/assets/awstack/AWSTACK_img_2_3@2x.png') + ')' : 'url(' + require('@/assets/awstack/AWSTACK_img_4_3@2x.png') + ')'}">
            <p class="desc">{{key=='1'? '对服务器、网络设备和电力供应设备有一体化交付要求的场景' : '对静音、散热有特殊要求的场景'}}</p>
          </li>
          <li :style="{'background-image': key == '1' ? 'url(' + require('@/assets/awstack/AWSTACK_img_2_4@2x.png') + ')' : 'url(' + require('@/assets/awstack/AWSTACK_img_4_4@2x.png') + ')'}">
            <p class="desc">{{key=='1'? '对容量、安全性要求较高的场景' : '自带监控触摸屏，可第一时间发现故障并告警，满足对故障反馈实时性的要求'}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    data() {
        return {
            key: '1'
        }
    },
    methods: {
        choose(val) {
            this.key = val
        }
    }
}
</script>